import React from 'react';
import './Whatsapp.css';

const Whatsapp = ({phone, text, message, icon}) => {
    const whatsappClickHandler = e => {
        window.gtag('event', 'hn-whatsapp-clicked', {
            type: 'whatsapp-click',
            name: 'whatsapp'
        });
    }

    return (
        <a onClick={whatsappClickHandler} href={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`} target={"_blank"} className={"Whatsapp"}>
            <img src={icon} />
            {text}
        </a>
    );
};

export default Whatsapp;
